// StripePayment.jsx
import React, { useState } from "react";
import { useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";

export default function StripePayment({ clientSecret, cart, onSuccess, onError }) {
  const stripe = useStripe();
  const elements = useElements();
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setIsLoading(true);
    setMessage("");

    try {
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        confirmParams: { return_url: window.location.origin + "/payment-success" },
        redirect: "if_required",
      });

      if (error) {
        console.error("Erreur Stripe:", error);
        setMessage(error.message || "Erreur inattendue");
        onError?.(error.message);
      } else if (paymentIntent) {
        // 💾 Enregistrer le paiement côté backend si nécessaire
        await fetch("https://d4unaturally.com/api/stripe/confirm-payment.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            payment_intent_id: paymentIntent.id,
            amount: paymentIntent.amount / 100, // USD
            currency: paymentIntent.currency,
            items: cart.items,
          }),
        });

        onSuccess?.({
          paymentId: paymentIntent.id,
          amount: paymentIntent.amount / 100,
          currency: paymentIntent.currency,
        });
      }
    } catch (err) {
      console.error("Erreur lors du paiement:", err);
      setMessage("Une erreur inattendue est survenue lors du paiement");
      onError?.("Une erreur inattendue est survenue lors du paiement");
    }

    setIsLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="payment-element-container border border-gray-300 rounded-lg p-4">
        <PaymentElement />
      </div>

      <button
        type="submit"
        disabled={!stripe || isLoading}
        className="w-full bg-gray-800 text-white py-4 rounded-lg hover:bg-yellow-500 transition disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isLoading ? "Traitement du paiement..." : `Payer ${(cart.total/10).toFixed(2)} USD`}
      </button>

      {message && (
        <div className="p-4 bg-red-50 border border-red-200 rounded-lg text-red-700 text-center mt-4">
          {message}
        </div>
      )}
    </form>
  );
}
